import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./home.scss";
import axios from "axios";
import SlideInModal from "../../components/slideInModal/SlideInModal";
import CustomerProfile from "../../components/customerProfile/CustomerProfile";
import Loading from "../../components/loading/Loading";

const Customers = () => {
  const [orders, setOrders] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [resetOrder, setResetOrder] = useState(false);

  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "buyerId", headerName: "ID", width: 130 },
    { field: "status", headerName: "Status", width: 80 },
    { field: "customer", headerName: "Customer", width: 250 },
    { field: "city", headerName: "City", width: 150 },
    { field: "address", headerName: "Address", width: 300 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "contactName", headerName: "Contact Name", width: 200 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "salespersonCode", headerName: "Sales Person", width: 200 },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-all-customers");
        const mappedOrders = response.data.map((customer) => ({
          id: customer._id,
          customer: customer.fullName || "",
          city: customer.city || "",
          address: customer.address || "",
          homeName: customer.homeName || "",
          salespersonCode: customer.salespersonCode || "",
          phone: customer.phone || "",
          status: customer.isVerified || "",
          email: customer.email || " ",
          buyerId: customer.buyerId || " ",
          contactName: customer.contactName || " ",
        }));
        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    getAllOrders();
  }, []);

  return (
    <>
      <div>
        <SlideInModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setResetOrder((prev) => !prev);
          }}
        >
          {selectedCustomerId && (
            <CustomerProfile
              cusId={selectedCustomerId}
              resetOrder={resetOrder}
            />
          )}
        </SlideInModal>
      </div>
      <div className="main_wrp">
        <div className="main_page_wrp">
          <div className="head_wrp">
            <h5>
              All <em>Customer</em>
            </h5>
          </div>
          <div className="main_body_wrp">
            {loading ? (
              <>
                <Loading />
              </>
            ) : (
              <DataGrid
                rows={orders}
                columns={columns}
                pageSize={5}
                onCellClick={(params) => {
                  setSelectedCustomerId(params.row.id);
                  setIsModalOpen(true);
                }}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                sx={{
                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers;
